import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/icons
import Search from '@material-ui/icons/Search';
// @material-ui/core components
import { List, ListItem } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
// core components
import Button from 'components/UI/CustomButtons/Button';
import CustomInput from 'components/UI/CustomInput/CustomInput';
// our components
import PermissionGroupStyles from 'assets/jss/PermissionSelect';
import InfoUser from 'components/common/InfoUser/InfoUser';

/**
 * @class
 * @extends React.Component
 */
class UserSelect extends Component {
  constructor(props) {
    super(props);
    this.timeoutId = 0;
  }

  /**
   * @description
   * Callback for handle the search input.
   *
   * @param {Object} e - Event object.
   * */
  handleSearch = e => {
    e.persist();
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      const { filter } = this.props;
      const contactInfo = e.target.value;
      filter({ contactInfo });
    }, 1000);
  };

  /**
   * @description
   * Render User Select component.
   */
  render() {
    const { classes, allUsers, selectUser, appliedFilter, t } = this.props;
    return (
      <React.Fragment>
        <div className={classes.selectuserContainer}>
          <CustomInput
            id="searchUsers"
            inputProps={{
              placeholder: t('user.select.placeholder'),
              inputProps: {
                'aria-label': 'Search',
              },
              startAdornment: (
                <InputAdornment position="end">
                  <Search className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
              onChange: this.handleSearch,
              defaultValue: appliedFilter.contactInfo,
            }}
            className={classes.groupSearch}
          />

          <List id="list-user" className={classes.selectUserList}>
            {allUsers &&
              allUsers.edges
                .filter(edge => edge.node.id !== '0')
                .map(edge => (
                  <ListItem
                    id={`user-select-list-${edge.node.id}`}
                    key={`user-${edge.node.id}`}
                    className={classes.listUserItem}
                  >
                    <Button
                      id={`user-select-${edge.node.id}`}
                      onClick={() => selectUser(edge.node)}
                      simple
                      color="primary"
                      className={classes.userBtn}
                      fullWidth
                    >
                      <InfoUser user={edge.node} />
                    </Button>
                  </ListItem>
                ))}
          </List>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * UserSelect PropTypes
 * @param classes - prop styles received from withStyles
 * @param allUsers - prop input users list
 * @param appliedFilter - prop to know applied filter
 * @param t - prop from HOC with string translations
 * @callback filter - callback function called to filter
 * @callback selectUser - callback function called when
 * user is selected
 */

UserSelect.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  allUsers: PropTypes.shape({}).isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  selectUser: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(PermissionGroupStyles)(UserSelect));
